import { EmeraldButton } from "@emerald-react/button";
import { EmeraldModal } from "@emerald-react/modal";
import { EmeraldNotification } from "@emerald-react/notification";
import { EmeraldStepperV2 } from "@emerald-react/stepper-v2";
import { RowReportModalProps } from "@survey/types/rowReportModal.types";

const RowReportModal = ({
  isOpen,
  onClose,
  onImport,
  importData,
  isImporting = false,
  entityName = "Properties",
}: RowReportModalProps) => {
  // Don't render modal at all if not open
  if (!isOpen) return null;

  return (
    <EmeraldModal
      opened={isOpen}
      onClose={onClose}
      title="Import from Excel"
      headerText="Import from Excel"
      hasCloseIcon={true}
      className="row-report-modal"
      actionTemplate={
        <>
          <EmeraldButton
            label="Cancel"
            type="Secondary"
            onClick={onClose}
            disabled={isImporting}
            className="mdc-dialog__button"
            color="primary"
            tabIndex={0}
          />
          <EmeraldButton
            label={
              isImporting
                ? "Importing..."
                : `Import ${importData?.toImport || 0} of ${importData?.totalProperties || 0} ${entityName}`
            }
            type="Primary"
            onClick={onImport}
            disabled={isImporting || !importData || importData.toImport === 0}
            tabIndex={0}
            className="mdc-dialog__button"
            color="primary"
          />
        </>
      }
    >
      <div className="flex flex-col max-h-[80vh]">
        {/* Header */}
        <div className="px-6">
          {/* Progress Indicator */}
          <EmeraldStepperV2
            onClick={function Ga() {}}
            orientation="horizontal"
            steps={[
              {
                id: "1",
                label: " Match Columns",
                state: "past",
              },
              {
                id: "2",
                label: "Row Report",
                state: "current",
              },
            ]}
          />
        </div>

        {/* Content */}
        <div className="flex-1 p-4 mb-4 flex flex-col gap-y-4 row-report-modal-notifications">
          {!importData ? (
            /* Loading state with focusable element */
            <div className="text-center py-8">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-green-500 mx-auto mb-4"></div>
              <p className="text-gray-600 mb-4">Processing import data...</p>
              <EmeraldButton
                label="Cancel"
                type="TextButton"
                onClick={onClose}
                tabIndex={0}
              />
            </div>
          ) : (
            <>
              {/* EmeraldNotification for success notification */}
              <div className="mb-4">
                <EmeraldNotification
                  variant="success"
                  closable={false}
                  title={`${importData.toImport} ${entityName} to import`}
                  message={`We'll add ${importData.toImport} ${entityName.toLowerCase()} from your file to your Survey.`}
                />
              </div>

              {/* EmeraldNotification for warning notification - Only show if geocodingErrors > 0 */}
              {importData.notImported && importData.notImported > 0 ? (
                <div className="mb-4">
                  <EmeraldNotification
                    variant="warning"
                    closable={false}
                    title={`${importData.geocodingErrors} ${entityName.slice(0, -1)} won't be imported`}
                    message="Missing Address information. Please provide Address, City, State or Latitude Longitude."
                  />
                </div>
              ) : (
                <></>
              )}
            </>
          )}
        </div>
      </div>
    </EmeraldModal>
  );
};

export default RowReportModal;
